import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ScanTableRequestModel } from "./ScanTableRequestModel";

@Injectable()
export class DataService_Student_Scan_History {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	StudentScanTableInfoSelectList(parms: ScanTableRequestModel) {
		var postResult$ = new Subject();
		var url = "Scans/StudentScanTableInfoSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentScanStatsSelect(parms: ScanTableRequestModel) {
		var postResult$ = new Subject();
		var url = "Scans/StudentScanStatsSelect";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentEntryScanInfoSelectList(ScanID) {
		var postResult$ = new Subject();
		var url = "Scans/StudentEntryScanInfoSelectList?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentExitScanInfoSelectList(ScanID) {
		var postResult$ = new Subject();
		var url = "Scans/StudentExitScanInfoSelectList?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentMealScanInfoSelectList(ScanID) {
		var postResult$ = new Subject();
		var url = "Scans/StudentMealScanInfoSelectList?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentAccessScanInfoSelectList(ScanID) {
		var postResult$ = new Subject();
		var url = "Scans/StudentAccessScanInfoSelectList?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentTimeScanInfoSelectList(ScanID) {
		var postResult$ = new Subject();
		var url = "Scans/StudentTimeScanInfoSelectList?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentEventScanInfoSelectList(ScanID) {
		var postResult$ = new Subject();
		var url = "Scans/StudentEventScanInfoSelectList?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentManualScanInfoSelectList(ScanID) {
		var postResult$ = new Subject();
		var url = "Scans/StudentManualScanInfoSelectList?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentAlertScanInfoSelectList(ScanID) {
		var postResult$ = new Subject();
		var url = "Scans/StudentAlertScanInfoSelectList?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationModeList() {
		var postResult$ = new Subject();
		var url = "Scans/StationModeList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanResultInfoSelectList() {
		var postResult$ = new Subject();
		var url = "Scans/ScanResultInfoSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationReminderInfoSelectList(ScanID) {
		var postResult$ = new Subject();
		var url = "Scans/StationReminderInfoSelectList?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanBlockAlertSelectList(ScanID: number) {
		var postResult$ = new Subject();
		var url = "Scans/ScanBlockAlertSelectList?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
